import printJS from 'print-js';

export interface TicketData {
  qrCodeUrl: string;
  logoUrl?: string;
}

export interface PrintOptions {
  count: number;
  delayBetweenPrints?: number;
  onProgress?: (current: number, total: number) => void;
}

const generateTicketHTML = (data: TicketData): string => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta name="viewport" content="width=218">
</head>
<body style="margin: 0; padding: 0;">
  <table width="218" cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; margin: 0 auto;">
    <tr>
      <td style="text-align: center; padding: 8mm 2mm;">
        <div style="margin-bottom: 15px;">
          ${data.logoUrl ? `<img src="${data.logoUrl}" alt="Logo" style="width: 180px; height: auto; display: block; margin: 0 auto;" onerror="this.style.display='none'" />` : ''}
        </div>

        <div style="border-top: 2px solid #b41f3d; margin: 15px auto; width: 80%;"></div>

        <div style="margin: 20px 0;">
          <img src="${data.qrCodeUrl}" style="width: 180px; height: 180px; display: block; margin: 0 auto;" />
        </div>

        <div style="border-top: 2px solid #b41f3d; margin: 15px auto; width: 80%;"></div>

        <div style="margin: 20px 0; padding: 12px; background: #f8f8f8; border-radius: 8px;">
          <p style="font-size: 14px; font-weight: bold; margin: 0 0 8px 0; color: #333;">
            Escanea este código
          </p>
          <p style="font-size: 12px; margin: 0; line-height: 1.5; color: #555;">
            con la cámara de tu móvil<br/>
            para crear tu recuerdo<br/>
            personalizado de hoy
          </p>
        </div>

        <div style="border-top: 1px dashed #ccc; margin: 20px auto 15px; width: 90%;"></div>

        <p style="font-size: 10px; color: #999; margin: 0;">
          KOMBU · Momentos que perduran
        </p>
      </td>
    </tr>
  </table>
</body>
</html>
  `.trim();
};

/**
 * Pausa entre copias. Según su código, la app Kombu Printer del iPad tarda unos
 * 3,5-5 s por ticket (comprueba la impresora, espera 1,5 s a que se pinte y abre
 * otra conexión para imprimir), y la impresora Star admite una sola conexión a
 * la vez. Con 800 ms las copias se solapan y lo probable es que a partir de la
 * segunda se pierdan (spec 012; pendiente de confirmar en el restaurante).
 */
export const DEFAULT_DELAY_BETWEEN_PRINTS_MS = 5000;

const sleep = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const printTickets = async (
  data: TicketData,
  options: PrintOptions
): Promise<{ success: number; failed: number; errors: Error[] }> => {
  const { count, delayBetweenPrints = DEFAULT_DELAY_BETWEEN_PRINTS_MS, onProgress } = options;
  
  const result = {
    success: 0,
    failed: 0,
    errors: [] as Error[]
  };

  const html = generateTicketHTML(data);

  for (let i = 1; i <= count; i++) {
    try {
      if (onProgress) {
        onProgress(i, count);
      }

      printJS({
        printable: html,
        type: 'raw-html',
        scanStyles: false,
      });

      result.success++;

      if (i < count && delayBetweenPrints > 0) {
        await sleep(delayBetweenPrints);
      }
    } catch (error) {
      result.failed++;
      result.errors.push(error instanceof Error ? error : new Error(String(error)));
    }
  }

  return result;
};
